var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#F56264"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6633 15.9621C34.1122 15.5133 34.1122 14.7855 33.6633 14.3367C33.2145 13.8878 32.4867 13.8878 32.0378 14.3367L24 22.3745L15.9621 14.3367C15.5133 13.8878 14.7855 13.8878 14.3367 14.3367C13.8878 14.7855 13.8878 15.5133 14.3367 15.9621L22.3745 24L14.3367 32.0379C13.8878 32.4867 13.8878 33.2145 14.3367 33.6633C14.7855 34.1122 15.5133 34.1122 15.9621 33.6633L24 25.6255L32.0378 33.6633C32.4867 34.1122 33.2145 34.1122 33.6633 33.6633C34.1122 33.2145 34.1122 32.4867 33.6633 32.0379L25.6255 24L33.6633 15.9621Z",
    fill: "#F7F7FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4c299ea2d1a9e84139a305946fbea852.svg";
export { ForwardRef as ReactComponent };